// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/message.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/message.proto.
 */
export const file_v1_message: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_google_type_date]);

/**
 * @generated from message v1.DeleteMessageRequest
 */
export type DeleteMessageRequest = Message<"v1.DeleteMessageRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.DeleteMessageRequest.
 * Use `create(DeleteMessageRequestSchema)` to create a new message.
 */
export const DeleteMessageRequestSchema: GenMessage<DeleteMessageRequest> = /*@__PURE__*/
  messageDesc(file_v1_message, 0);

/**
 * @generated from message v1.DeleteMessageResponse
 */
export type DeleteMessageResponse = Message<"v1.DeleteMessageResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message v1.DeleteMessageResponse.
 * Use `create(DeleteMessageResponseSchema)` to create a new message.
 */
export const DeleteMessageResponseSchema: GenMessage<DeleteMessageResponse> = /*@__PURE__*/
  messageDesc(file_v1_message, 1);

/**
 * @generated from message v1.ListNumbersRequest
 */
export type ListNumbersRequest = Message<"v1.ListNumbersRequest"> & {
  /**
   * Date for listing numbers
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: string region = 3;
   */
  region: string;
};

/**
 * Describes the message v1.ListNumbersRequest.
 * Use `create(ListNumbersRequestSchema)` to create a new message.
 */
export const ListNumbersRequestSchema: GenMessage<ListNumbersRequest> = /*@__PURE__*/
  messageDesc(file_v1_message, 2);

/**
 * @generated from message v1.BetDetail
 */
export type BetDetail = Message<"v1.BetDetail"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * @generated from field: int32 bet_type_id = 2;
   */
  betTypeId: number;

  /**
   * @generated from field: repeated string indices = 3;
   */
  indices: string[];

  /**
   * @generated from field: double money = 4;
   */
  money: number;

  /**
   * @generated from field: string province_index = 5;
   */
  provinceIndex: string;
};

/**
 * Describes the message v1.BetDetail.
 * Use `create(BetDetailSchema)` to create a new message.
 */
export const BetDetailSchema: GenMessage<BetDetail> = /*@__PURE__*/
  messageDesc(file_v1_message, 3);

/**
 * @generated from message v1.ListNumbersResponse
 */
export type ListNumbersResponse = Message<"v1.ListNumbersResponse"> & {
  /**
   * @generated from field: repeated v1.BetDetail numbers = 1;
   */
  numbers: BetDetail[];
};

/**
 * Describes the message v1.ListNumbersResponse.
 * Use `create(ListNumbersResponseSchema)` to create a new message.
 */
export const ListNumbersResponseSchema: GenMessage<ListNumbersResponse> = /*@__PURE__*/
  messageDesc(file_v1_message, 4);

/**
 * @generated from message v1.GetMessageDetailRequest
 */
export type GetMessageDetailRequest = Message<"v1.GetMessageDetailRequest"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;
};

/**
 * Describes the message v1.GetMessageDetailRequest.
 * Use `create(GetMessageDetailRequestSchema)` to create a new message.
 */
export const GetMessageDetailRequestSchema: GenMessage<GetMessageDetailRequest> = /*@__PURE__*/
  messageDesc(file_v1_message, 5);

/**
 * @generated from message v1.MessageDetail
 */
export type MessageDetail = Message<"v1.MessageDetail"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: int32 customer_id = 3;
   */
  customerId: number;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * Date for calculating lottery results
   *
   * @generated from field: google.type.Date calculate_date = 5;
   */
  calculateDate?: Date;
};

/**
 * Describes the message v1.MessageDetail.
 * Use `create(MessageDetailSchema)` to create a new message.
 */
export const MessageDetailSchema: GenMessage<MessageDetail> = /*@__PURE__*/
  messageDesc(file_v1_message, 6);

/**
 * @generated from message v1.GetMessageDetailResponse
 */
export type GetMessageDetailResponse = Message<"v1.GetMessageDetailResponse"> & {
  /**
   * @generated from field: v1.MessageDetail message = 1;
   */
  message?: MessageDetail;
};

/**
 * Describes the message v1.GetMessageDetailResponse.
 * Use `create(GetMessageDetailResponseSchema)` to create a new message.
 */
export const GetMessageDetailResponseSchema: GenMessage<GetMessageDetailResponse> = /*@__PURE__*/
  messageDesc(file_v1_message, 7);

/**
 * @generated from message v1.ListMessagesRequest
 */
export type ListMessagesRequest = Message<"v1.ListMessagesRequest"> & {
  /**
   * Date for listing messages
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: string region = 3;
   */
  region: string;
};

/**
 * Describes the message v1.ListMessagesRequest.
 * Use `create(ListMessagesRequestSchema)` to create a new message.
 */
export const ListMessagesRequestSchema: GenMessage<ListMessagesRequest> = /*@__PURE__*/
  messageDesc(file_v1_message, 8);

/**
 * @generated from message v1.WinningMessageDetail
 */
export type WinningMessageDetail = Message<"v1.WinningMessageDetail"> & {
  /**
   * @generated from field: string winning_number = 1;
   */
  winningNumber: string;

  /**
   * @generated from field: string original_type = 2;
   */
  originalType: string;

  /**
   * @generated from field: double winning_amount = 3;
   */
  winningAmount: number;

  /**
   * @generated from field: double total_bet_amount = 4;
   */
  totalBetAmount: number;

  /**
   * @generated from field: string original_province_text = 5;
   */
  originalProvinceText: string;

  /**
   * @generated from field: string number = 6;
   */
  number: string;

  /**
   * @generated from field: int32 matches = 7;
   */
  matches: number;

  /**
   * @generated from field: int32 bet_type_id = 8;
   */
  betTypeId: number;
};

/**
 * Describes the message v1.WinningMessageDetail.
 * Use `create(WinningMessageDetailSchema)` to create a new message.
 */
export const WinningMessageDetailSchema: GenMessage<WinningMessageDetail> = /*@__PURE__*/
  messageDesc(file_v1_message, 9);

/**
 * @generated from message v1.MessageListItem
 */
export type MessageListItem = Message<"v1.MessageListItem"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated v1.WinningMessageDetail message_details = 3;
   */
  messageDetails: WinningMessageDetail[];

  /**
   * @generated from field: int32 customer_id = 4;
   */
  customerId: number;

  /**
   * @generated from field: string region = 5;
   */
  region: string;

  /**
   * Date for calculating lottery results
   *
   * @generated from field: google.type.Date calculate_date = 6;
   */
  calculateDate?: Date;

  /**
   * Bet amounts
   *
   * @generated from field: double lotto_two_digits_amount = 7;
   */
  lottoTwoDigitsAmount: number;

  /**
   * @generated from field: double lotto_three_digits_amount = 8;
   */
  lottoThreeDigitsAmount: number;

  /**
   * @generated from field: double lotto_four_digits_amount = 9;
   */
  lottoFourDigitsAmount: number;

  /**
   * @generated from field: double head_tail_amount = 10;
   */
  headTailAmount: number;

  /**
   * @generated from field: double special_prize_amount = 11;
   */
  specialPrizeAmount: number;

  /**
   * @generated from field: double straight_combo_amount = 12;
   */
  straightComboAmount: number;

  /**
   * @generated from field: double cross_combo_amount = 13;
   */
  crossComboAmount: number;

  /**
   * Win amounts
   *
   * @generated from field: double win_lotto_two_digits_amount = 14;
   */
  winLottoTwoDigitsAmount: number;

  /**
   * @generated from field: double win_lotto_three_digits_amount = 15;
   */
  winLottoThreeDigitsAmount: number;

  /**
   * @generated from field: double win_lotto_four_digits_amount = 16;
   */
  winLottoFourDigitsAmount: number;

  /**
   * @generated from field: double win_head_tail_amount = 17;
   */
  winHeadTailAmount: number;

  /**
   * @generated from field: double win_special_prize_amount = 18;
   */
  winSpecialPrizeAmount: number;

  /**
   * @generated from field: double win_straight_combo_amount = 19;
   */
  winStraightComboAmount: number;

  /**
   * @generated from field: double win_cross_combo_amount = 20;
   */
  winCrossComboAmount: number;

  /**
   * Calculated sums
   *
   * @generated from field: double sum_2digits = 21;
   */
  sum2digits: number;

  /**
   * @generated from field: double sum_3digits = 22;
   */
  sum3digits: number;

  /**
   * @generated from field: double sum_win_2digits = 23;
   */
  sumWin2digits: number;

  /**
   * @generated from field: double sum_win_3digits = 24;
   */
  sumWin3digits: number;
};

/**
 * Describes the message v1.MessageListItem.
 * Use `create(MessageListItemSchema)` to create a new message.
 */
export const MessageListItemSchema: GenMessage<MessageListItem> = /*@__PURE__*/
  messageDesc(file_v1_message, 10);

/**
 * @generated from message v1.ListMessagesResponse
 */
export type ListMessagesResponse = Message<"v1.ListMessagesResponse"> & {
  /**
   * @generated from field: repeated v1.MessageListItem messages = 1;
   */
  messages: MessageListItem[];
};

/**
 * Describes the message v1.ListMessagesResponse.
 * Use `create(ListMessagesResponseSchema)` to create a new message.
 */
export const ListMessagesResponseSchema: GenMessage<ListMessagesResponse> = /*@__PURE__*/
  messageDesc(file_v1_message, 11);

/**
 * @generated from service v1.MessageService
 */
export const MessageService: GenService<{
  /**
   * @generated from rpc v1.MessageService.DeleteMessage
   */
  deleteMessage: {
    methodKind: "unary";
    input: typeof DeleteMessageRequestSchema;
    output: typeof DeleteMessageResponseSchema;
  },
  /**
   * @generated from rpc v1.MessageService.ListNumbers
   */
  listNumbers: {
    methodKind: "unary";
    input: typeof ListNumbersRequestSchema;
    output: typeof ListNumbersResponseSchema;
  },
  /**
   * @generated from rpc v1.MessageService.GetMessageDetail
   */
  getMessageDetail: {
    methodKind: "unary";
    input: typeof GetMessageDetailRequestSchema;
    output: typeof GetMessageDetailResponseSchema;
  },
  /**
   * @generated from rpc v1.MessageService.ListMessages
   */
  listMessages: {
    methodKind: "unary";
    input: typeof ListMessagesRequestSchema;
    output: typeof ListMessagesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_message, 0);

